import script from "./RootSet.vue?vue&type=script&setup=true&lang=js"
export * from "./RootSet.vue?vue&type=script&setup=true&lang=js"

import "./RootSet.vue?vue&type=style&index=0&id=350d5b30&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350d5b30"]])

export default __exports__